import {
  SET_SHARE_NOT_FOUND,
  SET_SHARE_LOADING,
  SET_SHARE_AUTH_LOADING,
  SET_SHARE_PROVIDE_PASSWORD,
  SET_SHARE_PASSWORD_ERROR,
  GET_SHARE,
} from '../actions/Shares';

const initialState = {
  share: null,
  loading: false,
  authLoading: false,
  notFound: false,
  providePassword: false,
  passwordError: false,
};

export const Shares = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHARE_NOT_FOUND:
      return Object.assign({}, state, {
        notFound: action.status,
      });

    case SET_SHARE_LOADING:
      return Object.assign({}, state, {
        loading: action.loading,
      });

    case SET_SHARE_AUTH_LOADING:
      return Object.assign({}, state, {
        authLoading: action.loading,
      });

    case SET_SHARE_PROVIDE_PASSWORD:
      return Object.assign({}, state, {
        providePassword: action.providePassword,
      });

    case SET_SHARE_PASSWORD_ERROR:
      return Object.assign({}, state, {
        passwordError: action.passwordError,
      });

    case GET_SHARE:
      return Object.assign({}, state, {
        share: action.share,
      });

    default:
      return state;
  }
};
